// The risk workflow's data rules, shared by every page that works a risk (All Risks, GRC Security
// Insights). One definition each, so two pages never disagree about the same risk.

// Every risk type is mutated through the unified controller (keyed by the risk's GUID) with the
// unprefixed payload.
export const riskWorkflowEndpoints = (riskId) => ({
    update: `/unifiedrisks/${riskId}/update-status`,
    accept: `/unifiedrisks/${riskId}/accept`,
    assign: `/unifiedrisks/${riskId}/assign`,
    approveBase: `/unifiedrisks/${riskId}`,
    fieldPrefix: '',
});

// A RiskDetailsDto (GET /allrisks/details, /unifiedrisks/details) in the shape the workflow dialogs read.
export const toWorkflowRisk = (risk) => ({
    riskId: risk.id,
    riskTitle: risk.riskTitle,
    detailedRiskDescription: risk.riskDescription,
    remediationStatus: risk.remediationStatus,
    remediationTargetDate: risk.remediationTargetDate,
    userRating: risk.riskSeverity,
    riskName: risk.riskTitle,
    progressPercentage: risk.progressPercentage,
    remediationID: risk.remediationId,
    remediationType: risk.riskType,
    remediationAssignTo: risk.remediationAssignTo,
    primaryApprovalStatus: risk.primaryApprovalStatus,
    primaryApproverUserId: risk.primaryApproverUserId,
    secondaryApprovalStatus: risk.secondaryApprovalStatus,
    secondaryApproverUserId: risk.secondaryApproverUserId,
    remediation_plan: risk.actionDescription,
    remediationTitle: risk.remediationTitle || risk.riskTitle,
    jiraIssueKey: risk.jiraIssueKey,
    jiraIssueUrl: risk.jiraIssueUrl,
    serviceNowIncidentNumber: risk.serviceNowIncidentNumber,
    serviceNowIncidentUrl: risk.serviceNowIncidentUrl,
    dealId: risk.dealId || null,
    businessUnitId: risk.businessUnitId || null,
});

// The remediation type the Jira / ServiceNow dialogs expect for a risk type.
const TICKET_TYPES = {
    Deals: 'application', DarkWeb: 'darkweb', Ransomware: 'ransomware', Enterprise: 'enterprise',
    TPRM: 'tprm', AI: 'ai', BusinessUnits: 'businessunits', GRC: 'grc', External: 'external',
};
export const ticketTypeOf = (riskType) => TICKET_TYPES[riskType] || 'application';

// Risk statuses in which the risk is being, or has been, accepted.
export const ACCEPTANCE_STATUSES = ['Accepted', 'AcceptancePendingPrimaryApproval', 'AcceptancePendingSecondaryApproval'];

// The remediations page rule: a target date in the past on a remediation that is neither Completed
// nor Deferred.
export const isRemediationOverdue = (targetDate, remediationStatus, now = new Date()) => {
    if (!targetDate || remediationStatus === 'Completed' || remediationStatus === 'Deferred') return false;
    return new Date(targetDate) < now;
};

// The user a risk is assigned to: its remediation's assignee, else the risk's.
export const assignedUserIdOf = (risk) =>
    risk.remediationAssignTo ? parseInt(risk.remediationAssignTo, 10) : (risk.assignedToUserId ?? null);
